module.exports = __webpack_public_path__ + "img/pending-search.8b288921.png";